import React from "react";
import { Drawer, Form, Input, Switch, Button } from "antd";
import TextArea from "antd/es/input/TextArea";

const CreateRoles = ({
    visible,
    onClose,
    onFinish,
    form,
    editingItem,
}) => {
    return (
        <Drawer
            title={editingItem ? "Edit Roles" : "Add New Roles"}
            width={500}
            onClose={onClose}
            open={visible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item name="name" label="Roles Name">
                    <Input size="large" placeholder="Enter name" />
                </Form.Item>

                <Form.Item
                    name="status"
                    label="Status"
                    valuePropName="checked"
                >
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        style={{ transform: "scale(1.3)", marginTop: "4px" }}
                    />
                </Form.Item>

                <Form.Item>
                    <div
                        style={{
                            textAlign: "right",
                            display: "flex",
                            gap: "10px",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button size="large" type="primary" htmlType="submit">
                            {editingItem ? "Update" : "Create"}
                        </Button>
                        <Button size="large" onClick={onClose}>
                            Cancel
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default CreateRoles;